import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import LoginPage from './pages/login/page';
import DashboardLayout from './components/DashboardLayout';
// Import all dashboard pages - admin has many
const DashboardHome = lazy(() => import('./pages/dashboard/page'));
const CompaniesPage = lazy(() => import('./pages/dashboard/companies/page'));
const CompanyDetailPage = lazy(() => import('./pages/dashboard/companies/[id]/page'));
const CompanyMenusPage = lazy(() => import('./pages/dashboard/companies/[id]/menus/page'));
const MenuEditorPage = lazy(() => import('./pages/dashboard/companies/[id]/menus/[menuId]/page'));
const UsersPage = lazy(() => import('./pages/dashboard/users/page'));
const WallsPage = lazy(() => import('./pages/dashboard/walls/page'));
const DevicesPage = lazy(() => import('./pages/dashboard/devices/page'));
const ImportPage = lazy(() => import('./pages/dashboard/import/page'));
const AnalyticsPage = lazy(() => import('./pages/dashboard/analytics/page'));
const CompanyMediaPage = lazy(() => import('./pages/dashboard/companies/[id]/media/page'));

export default function App() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="text-gray-500">Loading...</div></div>}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<DashboardHome />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="companies" element={<CompaniesPage />} />
          <Route path="companies/:id" element={<CompanyDetailPage />} />
          <Route path="companies/:id/media" element={<CompanyMediaPage />} />
          <Route path="companies/:id/menus" element={<CompanyMenusPage />} />
          <Route path="companies/:id/menus/:menuId" element={<MenuEditorPage />} />
          <Route path="walls" element={<WallsPage />} />
          <Route path="devices" element={<DevicesPage />} />
          <Route path="import" element={<ImportPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Suspense>
  );
}
